<template>
  <div>
    <div class="chunk-similar">
      <div class="speaker-name" :style="{ color: speaker_colors[speaker][0] }">
        {{ speaker }}
      </div>
      <div
        class="left-marker"
        :style="{ backgroundColor: speaker_colors[speaker][0] }"
      />
      <div class="chunk-text">
        {{ chunk_text }}
      </div>
      <div
        class="play-episode"
        @click="
          pushRoute();
          $store.commit('updateChunkPlaybackSimilar', chunk_id);
          $store.commit('updateExploration', false);
        "
      >
        <img id="play" src="../assets/play_episode.png" alt="" />
        <div id="text">Play episode</div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import config from "../data/ecchr_config.json";
export default {
  name: "ChunkCard",
  props: {
    chunk_text: String,
    speaker: String,
    collection_id: String,
    chunk_id: String,
  },
  data() {
    return {
      speaker_colors: config["speaker_colors"],
    };
  },
  computed: {
    ...mapState(["similarities", "episode_id", "episode_index"]),
    // speakerName: function () {
    //   if (this.speaker != undefined) {
    //     let speaker = this.speaker.split(".")[0];
    //     speaker = this.matchedSpeaker[speaker];
    //     return speaker;
    //   }
    //   return "";
    // },
  },
  methods: {
    pushRoute() {
      if (this.episode_id != this.collection_id) {
        this.$router.push({ path: "/episode/" + this.collection_id });
        this.$store.commit("updateEpisodeId", this.collection_id);
      }
    },
  },
};
</script>

<style scoped>
.chunk-similar {
  display: grid;
  grid-template-columns: 15px auto;
  background-color: rgba(30, 30, 30, 1);
  border-radius: 8px;
  padding: 15px 22px 20px 22px;
  transition: 0.3s ease-in-out;
}
.chunk-text {
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  grid-column-start: 2;
  grid-column-end: 3;
  font-size: 16px;
  line-height: 21px;
  color: rgb(255, 255, 255);
  transition: 0.3s ease-in-out;
  opacity: 0.7;
}

.left-marker {
  grid-column-start: 1;
  grid-column-end: 2;
  justify-items: start;
  width: 3px;
  height: 100%;
  border-radius: 1.5px;
}

.speaker-name {
  font-weight: 700;
  grid-column-start: 1;
  grid-column-end: 3;
  padding-top: 5px;
  padding-bottom: 20px;
}

.play-episode {
  background-color: rgb(15, 15, 15);
  color: #a0a0a0;
  width: fit-content;
  margin-bottom: 0px;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  margin-top: 20px;
  grid-column-start: 1;
  grid-column-end: 3;
  display: grid;
  grid-template-areas: "play text";
}

.play-episode:hover {
  cursor: pointer;
}

#play {
  grid-area: play;
  width: 12px;
  place-self: center;
}

#text {
  grid-area: text;
  place-self: center;
  padding-left: 10px;
}
</style>